import { render, staticRenderFns } from "./role-add-or-update.vue?vue&type=template&id=1284b37e"
import script from "./role-add-or-update.vue?vue&type=script&lang=js"
export * from "./role-add-or-update.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports